import request from '@/utils/request'
import baseUrl from './baseUrl'

const BASE_URL = baseUrl + '/auth'

export default {
    qywxAuthUrl: baseUrl + '/wx/a',

    //通过手机验证码修改密码
    upPassByCode(data) {
        return request({
            url: BASE_URL + '/upPassByCode',
            method: 'post',
            data
        })
    },
    //发送短信验证码
    mobileCode(data) {
        return request({
            url: BASE_URL + '/mobileCode',
            method: 'post',
            data
        })
    },
    //登录后修改密码
    upPassByUserId(data) {
        return request({
            url: BASE_URL + '/upPassByUserId',
            method: 'post',
            data
        })
    },
    login(username, password) {
        return request({
            url: BASE_URL + '/validate',
            method: 'post',
            data: {
                username,
                password
            }
        })
    },
    //登录发送验证码
    mCode(data) {
        return request({
            url: BASE_URL + '/mCode',
            method: 'post',
            data
        })
    },
    //验证码登录
    mobilelogin(mobile, code) {
        return request({
            url: BASE_URL + '/mlogin',
            method: 'post',
            data: {
                mobile,
                code
            }
        })
    },
    getUserInfo() {
        return request({
            url: BASE_URL + '/getUserInfo',
            method: 'get'
        })
    },
    newGuid() {
        return request({
            url: BASE_URL + '/newGuid',
            method: 'get'
        })
    }
}
